(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/primary-onboarding/assets/javascripts/target.js') >= 0) return;  svs.modules.push('/templates/primary-onboarding/assets/javascripts/target.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const TargetType = svs.templates.primaryOnboarding.constants.TargetType;
const _svs$templates$primar = svs.templates.primaryOnboarding.utils,
  breakDownTarget = _svs$templates$primar.breakDownTarget,
  splitCsvString = _svs$templates$primar.splitCsvString,
  splitClassnameString = _svs$templates$primar.splitClassnameString,
  splitIdString = _svs$templates$primar.splitIdString;

const clearupInterestMaps = (map, key) => {
  const clearMapKeys = [];
  map.forEach((keySet, mapKey) => {
    if (keySet.has(key)) {
      keySet.delete(key);
    }
    if (keySet.size === 0) {
      clearMapKeys.push(mapKey);
    }
  });
  clearMapKeys.forEach(mapKey => {
    map.delete(mapKey);
  });
};
const addToInterestMapSet = (map, key, value) => {
  const set = map.get(key);
  if (!set) {
    map.set(key, new Set([value]));
  } else if (set.has(value)) {
    set.add(value);
  }
};
const targetsOfIntrest = new Map();
const classOfIntrest = new Map();
const idOfIntrest = new Map();
const clearupClassOfIntrest = key => {
  clearupInterestMaps(classOfIntrest, key);
};
const addToClassOfIntrest = (key, value) => {
  addToInterestMapSet(classOfIntrest, key, value);
};
const clearupIdOfIntrest = key => {
  clearupInterestMaps(idOfIntrest, key);
};
const addToIdOfIntrest = (key, value) => {
  addToInterestMapSet(idOfIntrest, key, value);
};
const breakDownSelector = target => splitClassnameString(target, s => splitIdString(s));
const breakDownTargets = target => splitCsvString(target).map(s => breakDownSelector(s));
const addTargetOfInterest = (target, key) => {
  targetsOfIntrest.set(key, target);
  const targetSplit = breakDownTargets(target).flat();
  targetSplit.forEach(target => {
    const _breakDownTarget = breakDownTarget(target),
      _breakDownTarget2 = _slicedToArray(_breakDownTarget, 2),
      targetType = _breakDownTarget2[0],
      cleanTarget = _breakDownTarget2[1];
    if (targetType === TargetType.Classname) {
      addToClassOfIntrest(cleanTarget, key);
    } else if (targetType === TargetType.Id) {
      addToIdOfIntrest(cleanTarget, key);
    }
  });
};
const removeTargetOfInteresetByKey = key => {
  if (targetsOfIntrest.has(key)) {
    targetsOfIntrest.delete(key);
  }
  clearupClassOfIntrest(key);
  clearupIdOfIntrest(key);
};
const hasClassNameOfInterest = classname => classOfIntrest.has(classname);
const hasIdOfInterest = id => idOfIntrest.has(id);
const hasTargetOfInterest = target => {
  const targetSplit = breakDownTargets(target).flat();
  let a = false;
  targetSplit.forEach(target => {
    const _breakDownTarget3 = breakDownTarget(target),
      _breakDownTarget4 = _slicedToArray(_breakDownTarget3, 2),
      targetType = _breakDownTarget4[0],
      cleanTarget = _breakDownTarget4[1];
    if (targetType === TargetType.Classname) {
      a = a || hasClassNameOfInterest(cleanTarget);
    } else if (targetType === TargetType.Id) {
      a = a || hasIdOfInterest(cleanTarget);
    }
  });
  return a;
};
const getTargestFromMap = (map, value) => {
  const targets = [];
  if (map.has(value)) {
    map.get(value).forEach(target => {
      if (targetsOfIntrest.has(target)) {
        targets.push(targetsOfIntrest.get(target));
      }
    });
  }
  return targets;
};
const getTargetsForClassname = classname => getTargestFromMap(classOfIntrest, classname);
const getTargetsForId = id => getTargestFromMap(idOfIntrest, id);
const getInterestsSize = () => targetsOfIntrest.size;

setGlobal('svs.templates.primaryOnboarding.target', {
  addTargetOfInterest,
  removeTargetOfInteresetByKey,
  hasClassNameOfInterest,
  hasIdOfInterest,
  hasTargetOfInterest,
  getTargetsForClassname,
  getTargetsForId,
  getInterestsSize
});

 })(window);